import { render, staticRenderFns } from "./item_menu.vue?vue&type=template&id=92262fee&scoped=true"
import script from "./item_menu.vue?vue&type=script&lang=js"
export * from "./item_menu.vue?vue&type=script&lang=js"
import style0 from "./item_menu.vue?vue&type=style&index=0&id=92262fee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92262fee",
  null
  
)

export default component.exports